<template>
  <div class="serial-number-upgrade-page">
    <hr class="separator" style="margin-top: 1px"/>

    <div>
      <div class="custom-text">
        <span class="user-manage" v-text="$t('SerialNumberUpgrade.title')"></span>
      </div>
      <hr class="separator"/>
    </div>
    
    <div class="content-container">
      <div class="search-area">
        <!-- 搜索组件 -->
        <SearchBar @search="handleSearch" ref="searchBar" />
      </div>

      <!-- 表格组件 -->
      <DataTable 
        :tableData="tableData"
        :loading="loading"
        @refresh="loadData"
        @delete="handleDelete"
      />

      <!-- 分页组件 -->
      <div class="pagination">
        <PaginationBar 
          :totalRecords="totalRecords"
          :current-page="currentPage"
          :page-size="pageSize"
          @page-change="handlePageChange"
          @page-size-change="handlePageSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import {
  getSerialNumberUpgrades,
  deleteSerialNumberUpgrade
} from '@/api/api';
import SearchBar from './components/SearchBar.vue';
import DataTable from './components/DataTable.vue';
import PaginationBar from '@/components/PaginationBar.vue';

export default {
  components: {
    SearchBar,
    DataTable,
    PaginationBar
  },
  data() {
    return {
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      searchQuery: ''
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    // 加载数据
    async loadData() {
      this.loading = true;
      try {
        const query = {};
        if (this.searchQuery && this.searchQuery.trim() !== '') {
          query["name-like"] = this.searchQuery.trim();
        }
        const data = await getSerialNumberUpgrades(this.currentPage, this.pageSize, query);
        
        // 处理字段映射，确保数据库字段正确映射到表格显示的属性
        this.tableData = (data.data || []).map(item => ({
          ...item,
          firmwareFile: item.firmware_file_name || item.firmware_file, // 优先使用文件名
          firmwareFileUrl: item.firmware_file_url, // 映射固件文件URL
          paramsFile: item.params_file_name || item.params_file, // 优先使用参数文件名
          paramsFileUrl: item.params_file_url, // 映射参数文件URL
          params_file: item.params_file, // 保留原始的params_file字段(用于key)
          description: item.desc // 映射描述字段
        }));
        
        this.totalRecords = data.meta ? data.meta.total : 0;
        this.currentPage = data.meta ? data.meta.current_page : 1;
        this.pageSize = data.meta ? data.meta.per_page : 10;
      } catch (error) {
        console.error(error);
        ElMessage.error(this.$t('SerialNumberUpgrade.loadDataFailed'));
      } finally {
        this.loading = false;
      }
    },

    // 搜索处理
    async handleSearch(searchQuery) {
      this.searchQuery = searchQuery;
      this.currentPage = 1;
      await this.loadData();
    },

    // 分页处理
    handlePageChange(newPage) {
      this.currentPage = newPage;
      this.loadData();
    },

    handlePageSizeChange(newSize) {
      this.pageSize = newSize;
      this.loadData();
    },

    // 处理删除
    async handleDelete(id) {
      try {
        await deleteSerialNumberUpgrade(id);
        ElMessage.success(this.$t('SerialNumberUpgrade.deleteSuccess'));
        this.loadData();
      } catch (error) {
        console.error(error);
        ElMessage.error(this.$t('SerialNumberUpgrade.deleteFailed'));
      }
    }
  }
};
</script>

<style scoped>
@import "@/assets/css/publicStyle.css";

.serial-number-upgrade-page {
  width: 100%;
  min-height: 0;
  height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
}

.content-container {
  width: 100%;
  flex: 1;
  min-height: 0;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

.search-area {
  margin-bottom: 16px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-bottom: 20px;
}

.button-background-color {
  background-color: #409EFF;
  border-color: #409EFF;
  color: white;
}

.button-background-color:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
  color: white;
}
</style>